module.exports = __webpack_public_path__ + "img/kpxjt_right_unselect.411202e7.png";